/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export const LAYOUT_TODO_INBOX_DONE = 'todoInboxDone';
export const LAYOUT_TODO_PASSED = 'todoPassed';
